<template>
    <b-skeleton-wrapper
        :loading="loading"
    >
        <template #loading>
            <b-list-group class="mt-2">
                <b-list-group-item class="text-center">
                    <b-spinner variant="primary"></b-spinner>
                </b-list-group-item>
            </b-list-group>
        </template>
        <div class="mt-2">
            <slot
                v-if="attendanceSheet && attendanceSheet.id"
                :attendanceSheet="attendanceSheet"
                :refresh="loadAttendanceSheet"
            >
                <b-list-group-item active>
                    <b>Viewing attendance for {{ $moment(attendanceSheet.date).format("dddd, LL") }}</b>
                </b-list-group-item>
                <table class="table table-bordered">
                    <tr
                        v-for="student in students"
                        :key="student.id"
                    >
                        <td><b>{{ student.first_name }} {{ student.last_name }}</b></td>
                        <td class="text-center">
                            <b-badge
                                class="attendance-status"
                                :variant="attendanceVariant[attendance[student.id]]"
                            >
                                {{ attendanceEnum[attendance[student.id]] }}
                            </b-badge>
                        </td>
                    </tr>
                </table>
            </slot>
            <slot
                v-else
                name="no-attendance-sheet"
                :refresh="loadAttendanceSheet"
            ></slot>
        </div>
    </b-skeleton-wrapper>
</template>
<script>
export default {
    props: {
        students: Array,
        class_id: Number,
        date:     String
    },
    data() {
        return {
            loading:         true,
            attendanceEnum:  ["Absent", "Present", "Checked-In", "Out Sick", "Not coming"],
            attendanceVariant: ["danger", "info", "warning", "success", "secondary"],
            attendanceSheet: {},
            attendance: {},
            pdfUrl: ""
        };
    },
    mounted() {
        this.loadAttendanceSheet();
    },
    methods: {
        loadAttendanceSheet() {
            this.loading = true;
            this.$api.get("/api/teacher/get-attendance-sheet", {
                params: {
                    class_id: this.class_id,
                    date:     this.date
                }
            }).then(({ data: { attendance_sheet, pdf_url } }) => {
                if (attendance_sheet) {
                    try {
                        this.attendance = JSON.parse(attendance_sheet.record);
                    }
                    catch {
                        this.attendance = {};
                    }
                    this.attendanceSheet = attendance_sheet;
                    this.pdf_url         = pdf_url;
                    this.$emit("loaded", attendance_sheet, pdf_url);
                }
                this.loading = false;
            });
        },
    },
    watch: {
        attendanceSheet(newAttendanceSheet) {
            this.attendance = JSON.parse(newAttendanceSheet.record);
        }
    }
}
</script>
<style scoped>
    .attendance-status {
        min-width: 5rem;
    }
</style>